import React from 'react'
import { UserValidationFields } from 'shared/entities-validator/user-fields-validators'

export type SelfSignupFormFieldsContextType = {
  fields: UserValidationFields[]
  privacyPolicyUrl?: string | null
  isAdditionalInfoForm?: boolean
}

export const SelfSignupFormFieldsContext =
  React.createContext<SelfSignupFormFieldsContextType>(
    null as unknown as SelfSignupFormFieldsContextType
  )

export const useSelfSignupFormFieldsContext = () =>
  React.useContext(SelfSignupFormFieldsContext)
